import { useQuery } from '@tanstack/react-query';

import { getSyncLogs } from '~/services/ExperiencesService';

import { experiencesQueryKeys } from './experiencesQueryKeys';

export function useGetSyncLogs(offerId: string) {
  return useQuery({
    queryKey: experiencesQueryKeys.syncLogsList(offerId),
    queryFn: ({ signal }) => getSyncLogs(offerId, signal),
    enabled: !!offerId,
  });
}
